export enum EditableFields {
	DeleteDriver = 'delete-driver',
	Image = 'image',
	UpdateDrivers = 'update-drivers'
};